import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { me } from '../../../shared/features/session/session.api';

/**
 * Reloads the signed-in user after a change to their own account, so the sidebar, the rows and what two-factor allows
 * all read the server's view. A failure keeps what is showing; a 401 signs out through the app's own listener.
 */
export function useRefreshCurrentUser() {
  const { setUser } = useCurrentUser();
  return () =>
    me()
      .then(setUser)
      .catch(() => undefined);
}
